import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { EchartService } from '../../../../core/services/echart.service';
import { Router } from '@angular/router';
import { TabService } from '../../../../core/services/tab.service';


@Component({
  selector: 'app-buyer-segmentation',
  templateUrl: './buyer-segmentation.component.html',
  styleUrls: ['./buyer-segmentation.component.scss']
})

export class BuyerSegmentationComponent implements OnInit {
  @ViewChild('myCharts') myCharts: ElementRef;
  @Input() projectId: any;
  echartsInstance: any;
  dataSource: any;

  noData: any;

  chartOptionPie = {
    // grid: {
    //   top: '30px'
    // },
    color: [],
    title: {
      text: 'Buyer Segmentation',
      top: '30px',
      left: '20px',
      textStyle: {
        fontFamily: 'Roboto',
        fontSize: 10
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a}<br/>{b} : {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      top: '60px',
      left: '20px',
      // align: 'left',
      // itemWidth: '10',
      itemHeight: '10',
      // itemGap: '10',
      textStyle: {
        // width: 76
      },

      data: []
      // data: ['Local investor', 'Local first home buyer', 'Local downsize', 'Other', 'Oversea investor']
    },
    series: [
      {
        name: 'Percentage',
        type: 'pie',
        radius: ['35%', '50%'],
        center: ['55%', '65%'],
        label: false,
        data: [
          // {value: 335, name: 'Local investor'},
          // {value: 310, name: 'Local first home buyer'},
          // {value: 234, name: 'Local downsize'},
          // {value: 135, name: 'Other'},
          // {value: 1548, name: 'Oversea investor'}
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };

  constructor(private echartService: EchartService, private router: Router, private tabService: TabService) {
  }

  ngOnInit(): void {
    this.echartService.getBuyerType(this.projectId).subscribe((res: any) => {
      console.log(res);
      this.dataSource = res.data;
      // const buyerTypeData = new Object();
      // if (0 in this.dataSource[0]) {
      //   propertyTpeData['Local owner occupier'] = this.dataSource['0'];
      //   this.chartOptionPie.legend.data.push('Local owner occupier');
      // }
      // if (1 in this.dataSource) {
      //   propertyTpeData['Oversea buyer'] = this.dataSource['1'];
      //   this.chartOptionPie.legend.data.push('Oversea buyer');
      // }
      if ((res.data[0] && Object.keys(res.data[0]).length !== 0) || (res.data[1] && Object.keys(res.data[1].details).length !== 0)) {
        this.chartOptionPie.series[0].data.push({
          value: this.dataSource[0]['1'],
          name: 'Oversea buyer',
        });
        this.chartOptionPie.legend.data.push('Oversea buyer');
        this.chartOptionPie.color.push('#05CD99');


        if (this.dataSource[1].details.localDownsizeYes !== 0) {
          this.chartOptionPie.series[0].data.push({
            value: this.dataSource[1].details['localDownsizeYes'],
            name: 'Local downsize buyer'
          });
          this.chartOptionPie.legend.data.push('Local downsize buyer');
          this.chartOptionPie.color.push('#FF0D90');
        }

        if (this.dataSource[1].details.localFirstHomeBuyerYes !== 0) {
          this.chartOptionPie.series[0].data.push({
            value: this.dataSource[1].details['localFirstHomeBuyerYes'],
            name: 'Local first home buyer'
          });
          this.chartOptionPie.legend.data.push('Local first home buyer');
          this.chartOptionPie.color.push('#8676FF');
        }

        if (this.dataSource[1].details.localInvestorYes !== 0) {
          this.chartOptionPie.series[0].data.push({
            value: this.dataSource[1].details['localInvestorYes'],
            name: 'Local investor'
          });
          this.chartOptionPie.legend.data.push('Local investor');
          this.chartOptionPie.color.push('#A7E7F2');

        }
        if (this.echartsInstance) {
          this.echartsInstance.setOption(this.chartOptionPie);
        }
      } else {
        this.noData = true;
        this.chartOptionPie.series[0].data.push({
          value: 0,
          name: 'N/A'
        });
        this.chartOptionPie.legend.data.push('N/A');
        this.chartOptionPie.color.push('#D3D3D3');
        this.echartsInstance.setOption(this.chartOptionPie);
      }
    });
  }

  onChartInit(ec) {
    console.log(ec);
    // ec.resize();
    this.echartsInstance = ec;
  }

  goToProject() {
    this.router.navigateByUrl('/projects/' + this.projectId + '/edit').then(() => {
      this.tabService.tabIndex = 7;
    });
  }
}
